<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="d08649ec90568-d1e215"><span id="pageii">
<h3 class="books-by-head"><em class="italic ">A Selection of Recent Titles by Graham Masterton available from Severn House</em></h3>
<h4 class="books-by-subtitle"><em class="italic ">The Sissy Sawyer Series</em></h4>
<p class="books-by-text">TOUCHY AND FEELY</p>
<p class="books-by-text">THE PAINTED MAN</p>
<p class="books-by-text-space-after">THE RED HOTEL</p>
<h4 class="books-by-subtitle"><em class="italic ">The Jim Rook Series</em></h4>
<p class="books-by-text">DEMON’S DOOR</p>
<p class="books-by-text-space-after">GARDEN OF EVIL</p>
<h4 class="books-by-subtitle"><em class="italic ">The Harry Erskine Series</em></h4>
<p class="books-by-text">MANITOU BLOOD</p>
<p class="books-by-text">BLIND PANIC</p>
<p class="books-by-text-space-after">PLAGUE OF THE MANITOU</p>
<h4 class="books-by-subtitle"><em class="italic ">The Night Warriors Series</em></h4>
<p class="books-by-text-space-after">THE NINTH NIGHTMARE</p>
<h4 class="books-by-subtitle"><em class="italic ">Anthologies</em></h4>
<p class="books-by-text">FESTIVAL OF FEAR</p>
<p class="books-by-text-space-after">FIGURES OF FEAR</p>
<h4 class="books-by-subtitle"><em class="italic ">Novels</em></h4>
<p class="books-by-text">BASILISK</p>
<p class="books-by-text">FIRE SPIRIT</p>
<p class="books-by-text">PETRIFIED</p>
<p class="books-by-text">COMMUNITY</p>
<p class="books-by-text">FOREST GHOST</p>
<p class="books-by-text-space-after">DROUGHT</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106588_epub_alb.vue?296812c0